import React from 'react';
import { Box, Typography } from '@mui/material';

interface EducationItem {
  year: string;
  degree: string;
  field: string;
  institution: string;
}

export const Education: React.FC = () => {
  const education: EducationItem[] = [
    { year: '2014', degree: 'Ph.D. (Dr.-Ing.)', field: 'Mechanical Engineering', institution: 'Karlsruhe Institute of Technology (KIT), Germany' },
    { year: '2007', degree: 'M.Sc.', field: 'Computer Engineering', institution: 'Amirkabir University of Technology, Iran' },
    { year: '2004', degree: 'B.Sc.', field: 'Physics', institution: 'Zanjan University, Iran' }
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{
        mb: 3,
        color: '#FFFFFF',
        fontFamily: '"Inter", sans-serif'
      }}>
        Education
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 1 }}>
        {education.map((edu) => (
          <Box
            component="li"
            key={edu.degree}
            sx={{ display: 'grid', gridTemplateColumns: '56px 1fr', gap: 2, alignItems: 'baseline' }}
          >
            <Typography sx={{ color: '#78909C', fontFamily: '"JetBrains Mono", monospace', fontSize: '13px' }}>
              {edu.year}
            </Typography>
            <Typography component="div" sx={{ fontSize: '14px', color: '#B0BEC5', lineHeight: 1.6 }}>
              <Box component="span" sx={{ color: '#FFFFFF', fontWeight: 500 }}>{edu.degree}, {edu.field}</Box>
              {' · '}{edu.institution}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
